import React, { useState } from "react";
import nameWithPhone from "../../../assets/images/name.png";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/icons/arrowleft.svg";
import { ReactComponent as Spinner } from "../../../assets/icons/spinner.svg";
import SideImage from "../SideImage";
import Logo from "../Logo";
import {
  useRegisterMutation,
  useLoginMutation,
} from "../../../store/auth/usersApiSlice";
import { setUserInfo, setToken } from "../../../store/auth/authSlice";
import { useDispatch } from "react-redux";

const Name = ({ onNext, email, password, onPrev }) => {
  const [name, setName] = useState("");
  const [isButtonValid, setIsButtonValid] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const dispatch = useDispatch();

  const [register, { isLoading }] = useRegisterMutation();
  const [login] = useLoginMutation();

  const handleNameChange = (e) => {
    setIsButtonValid(e.target.value !== "");
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await register({
        name,
        email,
        password,
      }).unwrap();

      dispatch(setUserInfo({ ...res }));

      const { token } = await login({
        email,
        password,
      }).unwrap();

      dispatch(setToken(token));

      if (token) {
        onNext(true, selectedOption);
      }
    } catch (error) {
    }
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  return (
    <section className="relative py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex flex-wrap px-4 -mx-4 xl:items-center items-center">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md lg:py-20 mx-auto ">
                <h3 className="font-heading text-f16 sm:text-h3 text-primary font-semibold mb-4 text-center">
                  Let's Get to Know You!
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="mb-6">
                    <label
                      className="block mb-1.5 text-sm text-primary font-semibold text-left"
                      htmlFor="name"
                    >
                      Enter Full Name
                    </label>
                    <input
                      className="w-full py-3 px-4 text-sm text-primary placeholder-gray-400 border-b-2 border-primary focus:border-primary focus:outline-none focus:bg-white"
                      type="text"
                      id="name"
                      required
                      onChange={handleNameChange}
                    />
                    <input
                      className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
                      type="email"
                      readOnly
                      hidden
                      value={email}
                    />
                    <input
                      className="w-full py-3 px-4 text-sm text-gray-900 placeholder-gray-400 border border-gray-200 focus:border-purple-500 focus:outline-purple rounded-lg"
                      type="text"
                      readOnly
                      hidden
                      value={password}
                    />
                  </div>
                  <h3 className="text-secondarytwo text-left mb-4">
                    What brings you here?
                  </h3>
                  <div className="flex flex-col gap-2 mb-10 ">
                    <div className=" flex flex-col gap-2">
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="option"
                          value="explore"
                          checked={selectedOption === "explore"}
                          onChange={handleOptionChange}
                          className="form-radio text-blue-500"
                        />
                        <span className="ml-2">Explore Platform</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="option"
                          value="manage"
                          checked={selectedOption === "manage"}
                          onChange={handleOptionChange}
                          className="form-radio text-blue-500"
                        />
                        <span className="ml-2">Manage Businesses</span>
                      </label>
                      <label className="inline-flex items-center">
                        <input
                          type="radio"
                          name="option"
                          value="search"
                          checked={selectedOption === "search"}
                          onChange={handleOptionChange}
                          className="form-radio text-blue-500"
                        />
                        <span className="ml-2">Search Businesses</span>
                      </label>
                    </div>
                  </div>
                  <button
                    className={`relative group block w-full mb-6 py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center mr-2 gap-4 ${
                      !isButtonValid &&
                      "disabled:cursor-not-allowed disabled:bg-disable"
                    }`}
                    type="submit"
                    disabled={!isButtonValid}
                  >
                    <span className="relative">
                      {isLoading ? <Spinner /> : "Next"}
                    </span>
                    <ArrowRight />
                  </button>
                </form>
                <button
                  className="inline-flex items-center justify-center mr-2 gap-4 text-primaryText font-bold"
                 
                >
                  <ArrowLeft  onClick={onPrev}/>
                  <span className="relative"  onClick={onPrev}>Go Back</span>
                </button>
              </div>
            </div>
            <SideImage
              image={nameWithPhone}
              positions="top-1/2 transform -translate-y-1/2 left-[-25%]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Name;
